import { CcRequirementSmartCompliance } from "server/models"
import { OrderType } from "client/utils"

export type CcRequirementSmartComplianceValidation = { [key in keyof CcRequirementSmartCompliance]?: string}

export interface CcRequirementSmartComplianceList { [complianceId: number]: CcRequirementSmartCompliance }
export interface CcRequirementSmartComplianceFilters {
    search?: string
}

export interface CcRequirementSmartComplianceState {
    complianceList: CcRequirementSmartComplianceList
    complianceIds: readonly number[]
    complianceEdit: CcRequirementSmartCompliance

    sortColumn: keyof CcRequirementSmartCompliance
    sortOrder: OrderType
    filters: CcRequirementSmartComplianceFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const CC_REQUIREMENT_SMART_COMPLIANCE_LIST = "CC_REQUIREMENT_SMART_COMPLIANCE_LIST"
export const CC_REQUIREMENT_SMART_COMPLIANCE_IDS = "CC_REQUIREMENT_SMART_COMPLIANCE_IDS"
export const CC_REQUIREMENT_SMART_COMPLIANCE_EDIT = "CC_REQUIREMENT_SMART_COMPLIANCE_EDIT"

export const CC_REQUIREMENT_SMART_COMPLIANCE_SORT = "CC_REQUIREMENT_SMART_COMPLIANCE_SORT"
export const CC_REQUIREMENT_SMART_COMPLIANCE_FILTERS = "CC_REQUIREMENT_SMART_COMPLIANCE_FILTERS"

export const CC_REQUIREMENT_SMART_COMPLIANCE_RELOAD_LIST = "CC_REQUIREMENT_SMART_COMPLIANCE_RELOAD_LIST"
export const CC_REQUIREMENT_SMART_COMPLIANCE_RELOAD_EDIT = "CC_REQUIREMENT_SMART_COMPLIANCE_RELOAD_EDIT"
